import { Icon } from 'leaflet';

/* Icon usage in map
  
Use default icon (same as before)
const defaultIcon = assetIcon;

Create a custom icon
shape: Choose between 'circle', 'square', or 'triangle' (default: 'circle')
fillColor: The fill color of the shape (default: '#0078FF')
strokeColor: The stroke (border) color (default: '#FFFFFF')
strokeWidth: The width of the stroke (default: 2)
size: The overall size of the icon (default: 30)
opacity: The transparency level (default: 1)


Example
const customSquareIcon = createAssetIcon({
  shape: 'square',
  fillColor: '#FF0000',
  strokeColor: '#000000',
  size: 40,
  opacity: 0.8
});

Create an icon with just some partial properties
const partialCustomIcon = createAssetIcon({
  fillColor: '#00FF00'
});
*/

interface AssetIconOptions {
  shape?: 'circle' | 'square' | 'triangle';
  fillColor?: string;
  strokeColor?: string;
  strokeWidth?: number;
  size?: number;
  opacity?: number;
}

export const createAssetIcon = ({
  shape = 'circle',
  fillColor = '#0078FF',
  strokeColor = '#FFFFFF',
  strokeWidth = 2,
  size = 30,
  opacity = 1,
}: AssetIconOptions = {}) => {
  const iconSize = size / 2;
  const shapes = {
    circle: `<circle cx="${size / 2}" cy="${size / 2}" r="${size / 2 - strokeWidth / 2}" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" opacity="${opacity}"/>`,
    square: `<rect x="${strokeWidth / 2}" y="${strokeWidth / 2}" width="${size - strokeWidth}" height="${size - strokeWidth}" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" opacity="${opacity}"/>`,
    triangle: `<polygon points="${size / 2},${strokeWidth} ${strokeWidth},${size - strokeWidth} ${size - strokeWidth},${size - strokeWidth}" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" opacity="${opacity}"/>`,
  };

  return new Icon({
    iconUrl:
      'data:image/svg+xml;charset=utf-8,' +
      encodeURIComponent(`
          <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" fill="none">
            ${shapes[shape]}
          </svg>
        `),
    iconSize: [iconSize, iconSize],
    iconAnchor: [iconSize / 2, iconSize],
    popupAnchor: [0, -size],
  });
};

// Default asset icon for backward compatibility
export const assetIcon = createAssetIcon();

export const markerIcon = new Icon({
  iconUrl:
    'data:image/svg+xml;charset=utf-8,' +
    encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32">
        <path fill="#0067DD" stroke="white" stroke-width="2" d="M16,3.5c-4.142,0-7.5,3.358-7.5,7.5c0,4.143,7.5,18.121,7.5,18.121S23.5,15.143,23.5,11C23.5,6.858,20.143,3.5,16,3.5z M16,14.584c-1.979,0-3.584-1.604-3.584-3.584S14.021,7.416,16,7.416S19.584,9.021,19.584,11S17.979,14.584,16,14.584z"/>
      </svg>
    `),
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30],
});
